
import { defineComponent, reactive, computed, onMounted } from "vue";
import { useRouter } from "vue-router";
import "vue3-pagination/dist/vue3-pagination.css";
import TutorialStep from "@/includes/TutorialStep.vue";
import { config } from "@/Config";

export default defineComponent({
  name: "TutorialStepSix",
  components: {
   TutorialStep
  },
  setup() {
    const router = useRouter();
    const state = reactive({
      userList: [] as any,
      data: {
        selectedEdocForm: {} as any,
        imageBaseUrl: "",

        
      },
      ui: {
        isLoading: {
          clientDocumentRetrieveWorkflow: false,
        },
        isPostLoading: {
          createFormTemplate: false,
        },
      },
    });
    state.data.imageBaseUrl = config.imageBaseUrl;

    onMounted(() => {
      console.log("Hello from Tutorial")
    });
      function redirectToStep6() {
      router.push({
        name: "admin-tutorial-five",
      });
    }


     function redirectToStep8() {
     router.push({
        name: "admin-tutorial-eight",
      });
    }
    return {
      state,
      redirectToStep6,
      redirectToStep8
    };
  },
});
